import React from 'react';

import PlaySmallIcon from '../../assets/icons/PlaySmallIcon';
import Modal, { Modals } from '../../modals/Modal';
import { BREAKPOINTS_VALUES, colorsPalette } from '../../theme';
import { LazyLoadImage } from '../LazyloadImage';
import { VideoInterface } from './Video';
import usePortraitStyles from './styles';

const PortraitVideo: React.FC<VideoInterface> = ({
  id,
  title,
  userName,
  previewUrl,
  background,
  handleClick,
  durationNumb,
  verseId,
  bumperUrl,
  shouldOpenInModal = false,
}) => {
  const classes = usePortraitStyles(background)();

  return (
    <Modal
      verseId={verseId}
      duration={durationNumb}
      title={title}
      expertName={userName}
      bumperUrl={bumperUrl}
    >
      {({ openModal }) => (
        <div
          className={classes.videoWrap}
          onClick={() => {
            if (shouldOpenInModal) {
              openModal(Modals.VideoModal);
              return;
            }

            if (handleClick) {
              handleClick(id);
            }
          }}
        >
          <LazyLoadImage
            className={classes.videoImg}
            path={previewUrl}
            alt={title}
            draggable={false}
            srcset={[{ width: 230 }, { width: 270 }, { width: 280 }, { width: 300 }]}
            sizes={`(max-width:${BREAKPOINTS_VALUES['sm']}px) 230px, (max-width: ${BREAKPOINTS_VALUES['md']}) 270px, (max-width:${BREAKPOINTS_VALUES['lg']}px) 280px, 300px`}
          />
          <div className={classes.btnWrap}>
            <PlaySmallIcon className={classes.btn} color={colorsPalette.white} />
          </div>
          <span className={classes.title} title={title}>
            {title}
          </span>
        </div>
      )}
    </Modal>
  );
};

export default PortraitVideo;
